var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Alerts'),_c('TheLoading'),_c('TheHeader'),_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }